module.exports = __webpack_public_path__ + "img/photo-0142.d307c67b.jpg";